import type { ReactNode } from 'react'
import styled from 'styled-components'
import { theme } from '../../config/theme'
import { Text } from '../../general'
import Tooltip from './Tooltip'

export type EditTooltipProps = {
  children: JSX.Element
  title: string | ReactNode | null
  testId?: string
}

export const TooltipTitle = styled(Text)`
  color: ${(props) => props.theme.color.neutral.color11};
`

const EditTooltip = ({ children, title, testId }: EditTooltipProps) => (
  <Tooltip
    color={theme.color.neutral.color3}
    placement="topLeft"
    title={title ? <TooltipTitle>{title}</TooltipTitle> : null}
    data-testid={testId ? `${testId}-edit-tooltip` : 'edit-tooltip'}
  >
    {children}
  </Tooltip>
)

export default EditTooltip
